import api from "@/services/modules/talent-pools";
import {
  SET_TALENT_POOLS,
  SET_IS_FETCHING_TALENT_POOLS,
  SET_CURRENT_TALENT_POOL,
  SET_IS_FETCHING_CURRENT_TALENT_POOL
} from "./mutations";
import {
  handleWithErrorMessage,
  handleWithGlobalMessage
} from "@/services/utils";

export const FETCH_TALENT_POOLS = "FETCH_TALENT_POOLS";
export const FETCH_CURRENT_TALENT_POOL = "FETCH_CURRENT_TALENT_POOL";
export const ADD_NEW_TALENT_POOL = "ADD_NEW_TALENT_POOL";
export const ADD_USERS_TO_TALENT_POOL = "ADD_USERS_TO_TALENT_POOL";
export const EDIT_TALENT_POOL = "EDIT_TALENT_POOL";
export const REMOVE_TALENT_POOL = "REMOVE_TALENT_POOL";

const actions = {
  async [FETCH_TALENT_POOLS]({ commit, dispatch }, params) {
    return handleWithErrorMessage({
      dispatch,
      request: () => api({ commit }).getTalentPools(params),
      setLoadingFunction: isLoading =>
        commit(SET_IS_FETCHING_TALENT_POOLS, isLoading),
      setDataFunction: ({ data }) => commit(SET_TALENT_POOLS, data)
    });
  },
  async [FETCH_CURRENT_TALENT_POOL]({ dispatch, commit }, id) {
    return handleWithErrorMessage({
      dispatch,
      request: () => api({ commit }).getTalentPool(id),
      setLoadingFunction: isLoading =>
        commit(SET_IS_FETCHING_CURRENT_TALENT_POOL, isLoading),
      setDataFunction: ({ data }) => commit(SET_CURRENT_TALENT_POOL, data)
    });
  },
  async [ADD_NEW_TALENT_POOL]({ dispatch, commit }, data) {
    const { data: newTalentPoolData } = await handleWithErrorMessage({
      dispatch,
      request: () => api({ commit }).addTalentPool(data)
    });
    dispatch(FETCH_TALENT_POOLS);
    return newTalentPoolData;
  },
  async [REMOVE_TALENT_POOL]({ dispatch, commit }, id) {
    await handleWithErrorMessage({
      dispatch,
      request: () => api({ commit }).deleteTalentPool(id)
    });
    dispatch(FETCH_TALENT_POOLS);
  },
  async [ADD_USERS_TO_TALENT_POOL]({ dispatch, commit }, { id, users }) {
    return handleWithGlobalMessage(
      () => api({ commit }).addUsersToTalentPool(id, users),
      dispatch
    );
  },
  async [EDIT_TALENT_POOL]({ dispatch, commit }, { id, data }) {
    return handleWithErrorMessage({
      dispatch,
      request: () => api({ commit }).editTalentPool(id, data),
      setLoadingFunction: isLoading =>
        commit(SET_IS_FETCHING_CURRENT_TALENT_POOL, isLoading),
      setDataFunction: ({ data }) => commit(SET_CURRENT_TALENT_POOL, data)
    });
  }
};

export default actions;
